import React, { ReactElement, useState } from 'react';
import { Button, Grid, Row, Col, Form, Tooltip, Whisper } from 'rsuite';
import { Text } from 'rsuite';
import IconIndicator from '../../../user-feedback/IconIndicator';
import Notice from '../../../user-feedback/Notice';
import AnnotatedCheckbox from 'src/components/form/AnnotatedCheckbox';

interface CheckProps {
  loading?: boolean;
  onPay?: () => void;
  error?: string;
}

const Check = ({ loading, onPay, error }: CheckProps): ReactElement => {
  const [value, setValue] = useState<Record<string, unknown>>({
    'i-understand-checkbox': false,
  });

  return (
    <Grid
      fluid
      data-testid="check-component"
    >
      {loading && (
        <Row className="mb-16">
          <Col xs={24}>
            <IconIndicator />
          </Col>
        </Row>
      )}

      <Row className="mb-16">
        <Col xs={24}>
          <Form
            className="mt-4"
            checkTrigger="blur"
            formValue={value}
            formDefaultValue={value}
            onChange={setValue}
            fluid
          >
            <Text as="p">
              Only select this if you intend to physically mail a paper check.
              Once confirmed, this cannot be switched to another payment method.
              A unique payment code and mailing instructions will be generated
              once you confirm.
            </Text>

            <fieldset
              aria-labelledby="certifications-heading"
              style={{ border: 'none', margin: 0, padding: 0 }}
            >
              <AnnotatedCheckbox
                label="I understand I must mail a paper check and this cannot be changed
              to another payment method once confirmed."
                name={`i-understand-checkbox`}
              />
            </fieldset>
          </Form>
        </Col>
      </Row>
      {error && (
        <Row className="mb-16">
          <Col xs={24}>
            <Notice message={error} />
          </Col>
        </Row>
      )}
      <Row className="pt-16">
        <Col xs={24}>
          <Whisper
            speaker={
              <Tooltip>Please select the checkbox above to proceed.</Tooltip>
            }
            trigger={!value['i-understand-checkbox'] ? 'hover' : 'none'}
          >
            <span>
              <Button
                className="btn-primary full-width"
                disabled={loading || !value['i-understand-checkbox']}
                onClick={onPay}
              >
                Select Check as your payment method
              </Button>
            </span>
          </Whisper>
        </Col>
      </Row>
    </Grid>
  );
};

export default Check;
